import Dinero from "dinero.js";

import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";

import { MediaContextProvider } from "../../styles/Media.js";

import MainNavigation from "../../components/mainNavigation/MainNavigation.jsx";
import InactivityModal from "../../components/modals/InactivityModal.jsx";
import NotificationTray from "../../components/notifications/NotificationTray.jsx";

import Dashboard from "../dashboard/Dashboard.jsx";
import Invites from "../invites/Invites.jsx";
import Invite from "../invites/Invite.jsx";
import Invoices from "../invoices/Invoices.jsx";
import Invoice from "../invoices/Invoice.jsx";
import Images from "../images/Images.jsx";
import Image from "../images/Image.jsx";
import CreateImage from "../images/CreateImage.jsx";
import CloneImage from "../images/CloneImage.jsx";
import Schedules from "../schedules/Schedules.jsx";
import Schedule from "../schedules/Schedule.jsx";
import Projects from "../projects/Projects.jsx";
import Project from "../projects/Project.jsx";
import ProjectSettings from "../projects/ProjectSettings.jsx";
import ProjectAllowlist from "../projects/ProjectAllowlist.jsx";
import ProjectUsers from "../projects/ProjectUsers.jsx";
import EntityUser from "../entity/EntityUser.jsx";
import Resource from "../resources/Resource.jsx";
import Account from "../account/Account.jsx";
import Documentation from "../documentation/Documentation.jsx";
import Support from "../support/Support.jsx";
import ProjectWizardConfigSelector from "../projectWizard/ProjectWizardConfigSelector.jsx";
import ProjectWizard from "../projectWizard/ProjectWizard.jsx";
import ScheduledMessage from "../../components/notifications/ScheduledMessage.jsx";

import { ROUTES } from "../../constants/routing.js";
import { ACTION_URI_CHUNKS } from "../../constants/entity.js";

import {
  dismissInactivityWarning,
  latestActivity
} from "../../state/reducers/authentication/authenticationActions.js";
import { doLogout } from "../../state/reducers/authentication/authenticationActions.js";
import { selectSystemNotification } from "../../state/reducers/notifications/notificationSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Console extends PureComponent {
  state = {
    sidebarVisible: true
  };

  componentDidMount() {
    const { locale } = this.props;
    Dinero.globalLocale = locale;
  }

  closeInactivityModal = confirmed => {
    if (confirmed) {
      this.props.updateLatestActivity();
    } else {
      this.props.doLogout();
    }
    this.props.dismissInactivityWarning();
  };

  render() {
    const { systemNotification, isInactivityWarning, copy } = this.props;
    return (
      <MediaContextProvider>
        <MainNavigation />
        <div className="main-content">
          {systemNotification && (
            <ScheduledMessage
              title={systemNotification.title}
              message={systemNotification.message}
              startTime={systemNotification.startTime}
              endTime={systemNotification.endTime}
            />
          )}
          <Switch>
            <Route
              exact
              path={`${ROUTES.INVITES}/:id/:action`}
              component={Invite}
            />
            <Route exact path={`${ROUTES.INVITES}/:id`} component={Invite} />
            <Route path={ROUTES.INVITES} component={Invites} />
            <Route exact path={`${ROUTES.INVOICES}/:id`} component={Invoice} />
            <Route path={ROUTES.INVOICES} component={Invoices} />
            <Route
              exact
              path={`${ROUTES.IMAGES}/${ACTION_URI_CHUNKS.CREATE}/:type/:id`}
              component={CreateImage}
            />
            <Route
              exact
              path={`${ROUTES.IMAGES}/${ACTION_URI_CHUNKS.CLONE}/:type/:id`}
              component={CloneImage}
            />
            <Route exact path={`${ROUTES.IMAGES}/:id`} component={Image} />
            <Route path={ROUTES.IMAGES} component={Images} />
            <Route
              exact
              path={`${ROUTES.SCHEDULES}/:id`}
              component={Schedule}
            />
            <Route path={ROUTES.SCHEDULES} component={Schedules} />
            <Route
              exact
              path={`/:entitytype/:entityid${ROUTES.USERS}/:id`}
              component={EntityUser}
            />
            <Route
              exact
              path={`${ROUTES.PROJECTS}/:id${ROUTES.USERS}`}
              component={ProjectUsers}
            />
            <Route
              path={`${ROUTES.PROJECTS}/:id/settings`}
              component={ProjectSettings}
            />
            <Route
              path={`${ROUTES.PROJECTS}/:id/allowlist`}
              component={ProjectAllowlist}
            />
            <Route exact path={`${ROUTES.PROJECTS}/:id`} component={Project} />
            <Route path={ROUTES.PROJECTS} component={Projects} />
            <Route
              exact
              path={ROUTES.PROJECT_WIZARD}
              component={ProjectWizardConfigSelector}
            />
            <Route
              path={`${ROUTES.PROJECT_WIZARD}/:configId?/:step?/:id?`}
              component={ProjectWizard}
            />
            <Route
              exact
              path={`${ROUTES.RESOURCES}/:type/:id`}
              component={Resource}
            />
            <Route exact path={`${ROUTES.ACCOUNTS}/:tab`} component={Account} />
            <Route path={ROUTES.ACCOUNTS} component={Account} />
            <Route
              exact
              path={ROUTES.DOCUMENTATION}
              component={Documentation}
            />
            <Route exact path={ROUTES.SUPPORT} component={Support} />
            <Route component={Dashboard} />
          </Switch>
        </div>
        <NotificationTray />
        {isInactivityWarning === true && (
          <InactivityModal
            open={true}
            onClose={this.closeInactivityModal}
            countdown={true}
            copy={copy("authentication.inactivity_modal")}
          />
        )}
      </MediaContextProvider>
    );
  }
}

const mapStateToProps = state => ({
  isInactivityWarning: state.authentication.isInactivityWarning,
  locale: state.locale.locale,
  systemNotification: selectSystemNotification(state),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  dismissInactivityWarning: () => dispatch(dismissInactivityWarning()),
  doLogout: () => dispatch(doLogout()),
  updateLatestActivity: () => dispatch(latestActivity())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Console)
);
